module.exports = __webpack_public_path__ + "static/media/tabletop.bc33e41e.png";